import Axios from './instance';
import axios from 'axios'

const host = process.env.REACT_APP_APIHOST;
const domain = process.env.REACT_APP_HOST;

const config = {
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

const logout = `${domain}/logout`;
const aboutMe = `${host}/users/aboutme`;
const blog = `${host}/users/blogs`;
const blogById = `${host}/users/blogbyid`;
const tag = `${host}/users/blogs/tags`;
const category = `${host}/users/blogs/categories`;
const userProfile = `${host}/users/account`;
const profilePicture = `${host}/users/photo`;
const userSetting = `${host}/users/setting`;
const children = `${host}/users/children`;
const contact = `${host}/users/contact`;
const childRecords = `${host}/users/childrecords`;
const childRecord = `${host}/users/childrecord`;
const childRecordById = `${host}/users/childrecordbyid`;
const childRecordByDocument = `${host}/users/childrecord/document`;
const pregnancyRecord = `${host}/users/pcrecord`;
const pregnancyRecords = `${host}/users/pregnancy_record`;
const pregnancyRecordsByDocument = `${host}/users/pregnancy_record/document`;
const medicalRecord = `${host}/users/general_medical`;
const medicalRecordByDocument = `${host}/users/general_medical/document`;
const medicalRecordById = `${host}/users/general_medicalbyid`;
const momdiaryById = `${host}/users/momdiarybyid`;
const momdiary = `${host}/users/momdiary`;
const pregnancyrecordById = `${host}/users/pregnancyrecordbyid`;
const thyroid = `${host}/users/thyroid`;
const thyroidById = `${host}/users/thyroidbyid`;
const bloodSugar= `${host}/users/bloodsugar`;
const bloodSugarById = `${host}/users/bloodsugarbyid`;
const bloodPressure = `${host}/users/bloodpressure`;
const bloodPressureById = `${host}/users/bloodpressurebyid`;
const vitals = `${host}/users/vitals/image`;
const contacts = `${host}/users/contacts`;
const shareRecord = `${host}/users/share`
const sharedRecord = `${host}/users/sharedrecord`;
const ovulation = `${host}/users/ovulation`;
const kickCounts = `${host}/users/kickcounts`;


export const postBlog = async (data) => {
  let response = await Axios.post(blog, data);
  return response;
}

export const editBlog = async (data) => {
  let response = await Axios.put(blog, data);
  return response;
}

export const getBlogs = async () => {
  let response = await Axios.get(blog);
  return response;
}

export const getBlogById = async (data) => {
  let response = await Axios.post(blogById, data);
  return response;
}

export const getTags = async () => {
  let response = await Axios.get(tag);
  return response;
}

export const getCategories = async () => {
  let response = await Axios.get(category);
  return response;
}

export const fetchAboutMe = async () => {
  let response = await Axios.get(aboutMe);
  return response;
}

export const postAboutMe = async (data) => {
  let response = await Axios.post(aboutMe, data);
  return response;
}

export const getUserProfile = async (data) => {
  let response = await Axios.post(userProfile);
  return response;
}

export const editProfile = async (data) => {
  let response = await Axios.post(userProfile, data);
  return response;
}

export const uploadProfilePicture = async (data) => {
  let response = await Axios.post(profilePicture, data);
  return response;
}

export const getUserChildren = async () => {
  let response = await Axios.get(children);
  return response;
}

export const getChildRecords = async (data) => {
  let response = await Axios.post(childRecords, data);
  return response;
}

export const addChildRecords = async (data) => {
  let response = await Axios.post(childRecord, data, config);
  return response;
}

export const editChildRecords = async (data) => {
  let response = await Axios.put(childRecord, data, config);
  return response;
}

export const deleteChildRecord = async (data) => {
  let response = await Axios.delete(childRecord, data);
  return response;
}

export const deleteChildImage = async (data) => {
  let response = await Axios.delete(childRecord + '/image', data);
  return response;
}

export const getMedicalRecords = async () => {
  let response = await Axios.get(medicalRecord);
  return response;
}

export const addMedicalRecords = async (data) => {
  let response = await Axios.post(medicalRecord, data, config);
  return response;
}

export const editMedicalRecords = async (data) => {
  let response = await Axios.put(medicalRecord, data, config);
  return response; 
}

export const deleteMedicalRecords = async (data) => {
  let response = await Axios.delete(medicalRecord, data);
  return response;
}

export const deleteMedicalImage = async (data) => {
  let response = await Axios.delete(medicalRecord + "/image", data);
  return response;
}

export const getMomDiary = async () => {
  let response = await Axios.get(momdiary);
  return response;
}

export const getSingleMomDiary = async (data) => {
  let response = await Axios.post(momdiaryById, data);
  return response;
}

export const addMomDiary = async (data) => {
  let response = await Axios.post(momdiary, data, config);
  return response;
}

export const editMomDiary = async (data) => {
  let response = await Axios.put(momdiary, data, config);
  return response;
}

export const downloadMomDiary = async (data) => {
  let response = await Axios.post(momdiary + "/download", data, {responseType: 'blob'});
  return response;
}

export const deleteMomDiary = async (data) => {
  let response = await Axios.delete(momdiary, data);
  return response;
}

export const deleteDiaryImage = async (data) => {
  let response = await Axios.delete(momdiary + "/image", data);
  return response;
}

export const getSingleChildRecord = async (data) => {
  let response = await Axios.post(childRecordById, data);
  return response;
}

export const getSinglePregnancyRecord = async (data) => {
  let response = await Axios.post(pregnancyrecordById, data);
  return response;
}

export const addPregnancyRecord = async (data) => {
  let response = await Axios.post(pregnancyRecord, data, config);
  return response;
}

export const getPregnancyRecord = async (data) => {
  let response = await Axios.post(pregnancyRecords, data);
  return response;
}

export const getPregnancyRecordByDocument = async (data) => {
  let response = await Axios.post(pregnancyRecordsByDocument, data);
  return response;
}

export const editPregnancyRecord = async (data) => {
  let response = await Axios.put(pregnancyRecord, data, config);
  return response;
}

export const deletePregnancyRecord = async (data) => {
  let response = await Axios.delete(pregnancyRecord, data);
  return response;
}

export const deletePregnancyImage = async (data) => {
  let response = await Axios.delete(pregnancyRecord + '/image', data);
  return response;
}

export const getMedicalRecordByDocument = async (data) => {
  let response = await Axios.post(medicalRecordByDocument, data);
  return response;
}

export const getChildRecordByDocument = async (data) => {
  let response = await Axios.post(childRecordByDocument, data);
  return response;
}

export const getSingleMedicalRecord = async (data) => {
  let response = await Axios.post(medicalRecordById, data);
  return response;
}

export const deleteChildren = async (data) => {
  let response = await Axios.delete(children, data);
  return response;
}

export const deleteContact = async (data) => {
  let response = await Axios.delete(contact, data);
  return response;
}

export const downloadPregnancyRecord = async (data) => {
  let response = await Axios.post(pregnancyRecord + "/download", data, {
    responseType: 'blob', 
   });
  return response;
}

export const downloadChildRecord = async (data) => {
  let response = await Axios.post(childRecord + "/download", data, {
    responseType: 'blob', 
  })
  return response;
}

export const downloadMedicalRecord = async (data) => {
  let response = await Axios.post(medicalRecord + "/download", data, {responseType: 'blob'});
  return response;
}

export const getAccountDetails = async (data) => {
  let response = await Axios.get(userSetting);
  return response;
}

export const editUserSetting = async (data) => {
  let response = await Axios.post(userSetting, data);
  return response;
}

export const getThyroidRecord = async () => {
  let response = await Axios.get(thyroid);
  return response;
}

export const postThyroid = async (data) => {
  let response = await Axios.post(thyroid, data);
  return response;
}

export const editThyroid = async (data) => {
  let response = await Axios.put(thyroid, data);
  return response;
}

export const deleteThyroid = async (data) => {
  let response = await Axios.delete(thyroid, data);
  return response;
}

export const deleteVitalsImage = async (data) => {
  let response = await Axios.delete(vitals, data);
  return response;
}

export const downloadThyroidRecord = async (data) => {
  let response = await Axios.post(thyroid + "/download", data, {responseType: 'blob'});
  return response;
}

export const getThyroidById = async (data) => {
  let response = await Axios.post(thyroidById, data);
  return response;
}

export const getBloodSugarRecord = async () => {
  let response = await Axios.get(bloodSugar);
  return response;
}

export const postBloodSugar = async (data) => {
  let response = await Axios.post(bloodSugar, data);
  return response;
}

export const editBloodSugar = async (data) => {
  let response = await Axios.put(bloodSugar, data);
  return response;
}

export const downloadBloodSugarRecord = async (data) => {
  let response = await Axios.post(bloodSugar + "/download", data, { responseType: "blob"})
  return response;
}

export const deleteBloodSugar = async (data) => {
  let response = await Axios.delete(bloodSugar, data);
  return response;
}

export const getBloodSugarById = async (data) => {
  let response = await Axios.post(bloodSugarById, data);
  return response;
}

export const getBloodPressureRecord = async () => {
  let response = await Axios.get(bloodPressure);
  return response;
}

export const postBloodPressure = async (data) => {
  let response = await Axios.post(bloodPressure, data);
  return response;
}

export const editBloodPressure = async (data) => {
  let response = await Axios.put(bloodPressure, data);
  return response;
}

export const downloadBloodPressureRecord = async (data) => {
  let response = await Axios.post(bloodPressure + "/download", data, { responseType: "blob"});
  return response;
}

export const deleteBloodPressure = async (data) => {
  let response = await Axios.delete(bloodPressure, data);
  return response;
}

export const getBloodPressureById = async (data) => {
  let response = await Axios.post(bloodPressureById, data);
  return response;
}

export const getContacts = async () => {
  let response = await Axios.get(contacts);
  return response;
}

export const postSharedRecord = async (data) => {
  let response = await Axios.post(shareRecord, data);
  return response;
}

export const getSharedRecord = async (data) => {
  let response = await axios.post(sharedRecord, data);
  return response;
}

export const downloadSharedRecord = async (data) => {
  let response = await axios.post(sharedRecord + "/download", data, {
    responseType: 'blob'
  });
  return response;
}

export const getOvulationData = async () => {
  let response = await Axios.get(ovulation);
  return response;
}

export const getKickCounts = async () => {
  let response = await Axios.get(kickCounts);
  return response;
}

export const destroySession = async () => {
  let response = await Axios.get(logout, { withCredentials: true});
  return response;
}


// WEBPACK FOOTER //
// ./src/views/services/aboutMe.js